<div class="u-h-100">
	<div class="page-not-found-container">

		<div class="page-not-found-panel">
			<h1 class="u-margin-b-4">Page Not Found</h1>
			<p class="u-margin-b-5 u-text-muted">
				We couldn't find the page you requested. The route may be unavailable or the tenant path may need to be refreshed.
			</p>

			<button type="button" class="btn btn-outline-secondary btn-sm text-start" (click)="returnToLanding()">
				Return to Landing
			</button>
		</div>
	</div>
</div>